enum SearchSortOrderBy {
    Relevance = 1,
    PrintOrder = 2,
}

export default SearchSortOrderBy;
